import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
} from "@chakra-ui/react";

export default function ConfirmationModal({
  show = false,
  onClose = () => {},
  onConfirm = () => {},
  content = "Are You Sure? This Item will be Deleted Permanently",
}) {
  return (
    <>
      {show ? (
        <Modal isOpen={show} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Delete Confirmation</ModalHeader>
            <ModalCloseButton />
            <div
              className="form-container"
              style={{ width: "100%", margin: 0 }}
            >
              <ModalBody style={{ width: "100%" }}>{content}</ModalBody>
              <ModalFooter>
                <Flex
                  flexDirection="row"
                  style={{ justifyContent: "space-between", width: "100%" }}
                >
                  <Button onClick={onConfirm}> Confirm</Button>
                  <Button> Cancel</Button>
                </Flex>
              </ModalFooter>
            </div>
          </ModalContent>
        </Modal>
      ) : null}
    </>
  );
}
